import React from "react";

const PageTwo = ({ onButtonClick }) => {
  return (
    <section className="aboutCover-container">
      <h2>AI Writing Your Cover Letter</h2>
      <p>Our AI is hard at work creating your cover letter</p>
    </section>
  );
};

export default PageTwo;
